import {
  RadioGroup as HeadlessRadioGroup,
  type RadioGroupProps as HeadlessRadioGroupProps,
} from "@headlessui/react";
import classNames from "classnames";
import { type ElementType, useContext } from "react";

import Description from "./Description";
import { FieldContext } from "./FieldContext";

export type RadioGroupProps<
  T extends ElementType = "div",
  TType = string,
> = HeadlessRadioGroupProps<T, TType> & {
  direction?: "horizontal" | "vertical";
  error?: string;
  description?: React.ReactNode;
};

export default function RadioGroup<TType = string>({
  className,
  direction = "horizontal",
  error,
  description,
  ...props
}: RadioGroupProps<"div", TType>) {
  const fieldContext = useContext(FieldContext);

  return (
    <div className={fieldContext.grid ? "sm:col-span-2" : undefined}>
      <HeadlessRadioGroup
        {...props}
        className={classNames(
          "flex gap-1.5",
          direction === "vertical" && "flex-col",
          className,
        )}
      />
      {(error || description) && (
        <Description variant={error ? "error" : "hint"} className="mt-1.5">
          {error || description}
        </Description>
      )}
    </div>
  );
}
